import api from '.';

export const operacaoByIdOrUUID = async (id, uuid) => {
    try {
        const { data } = await api.post('/operacao/operacaoByIdOrUUID', { id, uuid });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const operacao = async (uuid) => {
    try {
        const { data } = await api.get(`/operacao/editar/${uuid}`);
        return data;
    } catch (error) {
        return error;
    }
};
export const retornaOperacoes = async ({
    balanco,
    conferencia,
    entrada,
    industria,
    inventario,
    locacao,
    manutencao,
    saida,
    servico,
}) => {
    try {
        const { data } = await api.get('/serviceOPERACAO', {
            params: { balanco, conferencia, entrada, industria, inventario, locacao, manutencao, saida, servico },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const retornaOperacaoParametros = async (operacaoId, empresaId) => {
    if (!operacaoId || !empresaId) return [];

    try {
        const { data } = await api.get('/operacaoParametro/operacaoParametros', {
            params: { operacaoId, empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};

// consultas
export const situacaoByOperacao = async (obj) => {
    try {
        const { data } = await api.post('/situacaoByOperacao', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterOperacaoSituacaoByOperacaoIdEempresaId = async (obj) => {
    try {
        const { data } = await api.post('/obterOperacaoSituacaoByOperacaoIdEempresaId', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const centroCustoByOperacao = async (obj) => {
    const { uuid, empresaId } = obj;
    if (!uuid || !empresaId) {
        throw new Error('uuid e empresaId são obrigatórios.');
    }
    try {
        const { data } = await api.post('/centroCustoByOperacao', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterOperacaoSituacaoByOpParamId = async (obj) => {
    const { operacaoParametroId } = obj;
    if (!operacaoParametroId) {
        throw new Error('operação parametros Id é obrigatório.');
    }
    try {
        const { data } = await api.post('/obterOperacaoSituacaoByOpParamId', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

// transformação
export const listarTransformacao = (start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId) =>
    api.get('/operacaoParametro/listarTransformacao', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId },
    });
export const CreateOrEditTransformacao = async (objeto) => api.post(`operacaoParametro/CreateOrEditTransformacao`, objeto);
export const obterTransformacao = async (empresaId) => {
    try {
        const { data } = await api.get('/operacaoParametro/obterTransformacao', {
            params: { empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const duplicidadeTransformacao = async ({ operacaoId, operacaoParametroId, natureza, uuid }) => {
    try {
        const { data } = await api.get('/operacaoParametro/duplicidadeTransformacao/', {
            params: { operacaoId, operacaoParametroId, natureza, uuid },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const deletarTransformacao = (uuid) => api.post('/operacaoParametro/deletarTransformacao', { uuid });

// documento
export const listarDocumentos = (start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId) =>
    api.get('/operacaoParametro/listarDocumentos', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId },
    });
export const CreateOrEditDocumento = async (objeto) => api.post(`operacaoParametro/CreateOrEditDocumento`, objeto);
export const obterDocumentos = async (empresaId) => {
    try {
        const { data } = await api.get('/operacaoParametro/obterDocumentos', {
            params: { empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const duplicidadeDocumento = async (documentoId, operacaoParametroId, uuid) => {
    try {
        const { data } = await api.get('/operacaoParametro/duplicidadeDocumento/', {
            params: { documentoId, operacaoParametroId, uuid },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const deletarDocumento = (uuid) => api.post('/operacaoParametro/deletarDocumento', { uuid });

// tabela preco
export const listarTabelaPrecos = (start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId) =>
    api.get('/operacaoParametro/listarTabelaPrecos', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId },
    });

export const CreateOrEditTabelaPreco = async (obj) => api.post(`operacaoParametro/CreateOrEditTabelaPreco`, obj);

export const obterTabelaPrecos = async (empresaId) => {
    try {
        const { data } = await api.get('/operacaoParametro/obterTabelaPrecos', {
            params: { empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const duplicidadeTabelaPreco = async (obj) => {
    try {
        const { data } = await api.post('/operacaoParametro/duplicidadeTabelaPreco/', {
            empresaId: obj.empresaId,
            tabelaPrecoId: obj.tabelaPrecoId,
            operacaoParametroId: obj.operacaoParametroId,
            uuid: obj.uuid,
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const deletarTabelaPreco = (uuid) => api.post('/operacaoParametro/deletarTabelaPreco', { uuid });

// Situações permitidas
export const listarSituacoes = (start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId) =>
    api.get('/operacaoParametro/listarSituacoes', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId },
    });
export const managerSituacao = async (obj) => api.post(`operacaoParametro/managerSituacao`, obj);

// Operações permitidas
export const listarOperacoes = (start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId) =>
    api.get('/operacaoParametro/listarOperacoes', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, operacaoParametroId },
    });
export const managerOperacao = async (obj) => api.post(`operacaoParametro/managerOperacao`, obj);
